class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
        this.enableSticky();
        window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
    }

    enableSticky() {
        const sticky = this.getAttribute('data-sticky') == 'true';
        if (sticky) {
            // 设置全局样式--announcement-bar-height
            this.updateHeight();
        }
    }

    onResize() {
        this.updateHeight();
    }

    updateHeight() {
        const sticky = this.getAttribute('data-sticky') == 'true';
        if (sticky) {
            // 更新--announcement-bar-height的值
            document.documentElement.style.setProperty('--announcement-bar-height', this.offsetHeight + 'px');
        }
    }
}

customElements.define('announcement-bar', AnnouncementBar);
